import { DialogTitle, alpha, Stack, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

function ErrorTitle({ title }) {
  return (
    <DialogTitle
      sx={(theme) => ({
        textAlign: 'center',
        width: '100%',
        backgroundColor: alpha(theme.palette.error.main, 0.3),
        mb: '16px',
      })}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap={1}
      >
        <InfoIcon sx={(theme) => ({ color: theme.palette.error.main })} />
        <Typography
          id="error-dialog-title"
          sx={{ fontSize: '16px', fontWeight: 'bold' }}
        >
          {title}
        </Typography>
      </Stack>
    </DialogTitle>
  );
}

export default ErrorTitle;
